import * as React from 'react';
import {FunctionComponent} from 'react';
import {Report} from '../../../../../Models/Report';
import {Feedback} from '../../../../Components/Feedback';
import {Button} from '../../../../Components/Button';
import {SnippetSelector} from './SnippetSelector';
import {Snippet} from '../../../../../Models/Snippet';
import {SplitSelector} from './SplitSelector';
import {SplitStrategy} from '../../../../../Business/calculateSplitTimes';
import {PostProcessing} from '../../PostProcessing';
import {ReportData} from '../../Trend/TrendReportPresenter';

interface OwnProps {
    report?: Report;
    selectedSnippetIds: number[];
    snippets: Snippet[];
    splitStrategy: SplitStrategy;
    onChangeSplitStrategy: (splitStrategy: SplitStrategy) => void;
    onChangeSelectedSnippetIds: (snippets: number[]) => void;
    onDelete: () => void;
    deleting: boolean;
    onDeleteSnippet: (selectedSnippetId: number) => void;
}

export const Sidebar: FunctionComponent<OwnProps> = ({
    report,
    onDelete,
    deleting,
    splitStrategy,
    onChangeSplitStrategy,
    selectedSnippetIds,
    snippets,
    onChangeSelectedSnippetIds,
    onDeleteSnippet,
}) => {

    const reportData: ReportData = { snippets: snippets };

    return (
        <div>
            <PostProcessing reportData={reportData} className="mb-3" />
            <SplitSelector splitStrategy={splitStrategy} onChange={onChangeSplitStrategy} className="mb-3" />
            <SnippetSelector
                selectedSnippetIds={selectedSnippetIds}
                snippets={snippets}
                onChange={(snippetIds) => onChangeSelectedSnippetIds(snippetIds)}
                className="mb-3"
                onDeleteSnippet={(snippetId) => {onDeleteSnippet(snippetId)}}
            />
            <Feedback className="mb-3" />
            {report && (
                <div className="row mb-3">
                    <div className="col-12 text-center">
                        <Button
                            text={
                                <>
                                    <i className="bi-trash me-2" />
                                    Delete report
                                </>
                            }
                            onClick={() => {
                                if (confirm('Are you sure you want to delete this report?')) {
                                    onDelete();
                                }
                            }}
                            loading={deleting}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
